var fn = function( obj ){
var __t,__p='';
__p+='precision highp float;\n\nvarying vec3 vTexCoord;\nuniform sampler2D tLatLon;\n\n#define PI 3.1415926\n#define TAU 6.283184\n\nfloat atan2(in float y, in float x)\n{\n  if( abs(x) > abs(y) ){\n    return atan(y,x);\n  } else {\n    return PI/2.0 - atan(x,y);\n  }\n}\n\nvoid main( void ){\n\n\n  vec3 wDir = normalize( vTexCoord );\n  \n  vec2 tc = vec2( \n    - atan2(wDir.x, wDir.z)/TAU,\n    - asin(wDir.y)/PI + .5\n  );\n\n  gl_FragColor = texture2D( tLatLon, tc );\n\n}\n';
return __p;
};
fn.toString=fn;
module.exports = fn;